// extracted by mini-css-extract-plugin
export default {"info-icon":"ResetButton_info-icon__qLHw6"};